import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_DraggableTable.scss';
class PgDev_DraggableTable_class extends ComponentSync {
    draggedItemIndex = { current: null };
    draggedOverItemIndex = { current: null };
    deriveStateFromProps(nextProps) {
        const state = this.state || {
            data: [
                {
                    cellOne: '1-1',
                    cellTwo: '1-2',
                    cellThree: '1-3',
                }, {
                    cellOne: '2-1',
                    cellTwo: '2-2',
                    cellThree: '2-3',
                }, {
                    cellOne: '3-1',
                    cellTwo: '3-2',
                    cellThree: '3-3',
                }, {
                    cellOne: '4-1',
                    cellTwo: '4-2',
                    cellThree: '4-3',
                },
            ]
        };
        return state;
    }
    //Logic
    onDragStart = (e, rowIndex) => {
        this.draggedItemIndex.current = rowIndex;
    };
    onDragEnter = (e, rowIndex) => {
        if (this.draggedItemIndex.current === null)
            return;
        this.draggedOverItemIndex.current = rowIndex;
        const listCopy = [...this.state.data];
        const draggingItemContent = listCopy[this.draggedItemIndex.current];
        listCopy.splice(this.draggedItemIndex.current, 1);
        listCopy.splice(this.draggedOverItemIndex.current, 0, draggingItemContent);
        this.draggedItemIndex.current = this.draggedOverItemIndex.current;
        this.draggedOverItemIndex.current = null;
        this.setState({ data: listCopy });
    };
    render() {
        return _jsxs(LL_H_C, { children: [_jsx("div", { className: 'draggable-table-container', children: _jsxs("table", { className: 'draggable-table', children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "col1" }), _jsx("th", { children: "col2" }), _jsx("th", { children: "col3" })] }) }), _jsx("tbody", { children: this.state.data.map((row, rowIndex) => {
                                    return _jsxs("tr", { draggable: 'true', onDragStart: (e) => this.onDragStart(e, rowIndex), onDragOver: (e) => e.preventDefault(), onDragEnter: (e) => this.onDragEnter(e, rowIndex), children: [_jsx("td", { children: row.cellOne }), _jsx("td", { children: row.cellTwo }), _jsx("td", { children: row.cellThree })] }, rowIndex);
                                }) })] }) }), _jsx("div", { children: this.state.data.map((item, i) => {
                        return _jsx("div", { draggable: 'true', onDragStart: (e) => this.onDragStart(e, i), onDragEnter: (e) => this.onDragEnter(e, i), onDragOver: (e) => e.preventDefault(), children: item.cellOne });
                    }) })] });
    }
}
export const PgDev_DraggableTable = { name: 'Draggable Table', key: 'draggable-table', renderer: PgDev_DraggableTable_class };
